import { ref, computed, watch, onUnmounted } from 'vue'
import { useStore } from 'vuex'

export function useTheme() {
  const store = useStore()

  const themeMode = computed(() => store.getters['user/getThemeMode'] || 'system')

  const mediaQuery = window.matchMedia('(prefers-color-scheme: dark)')
  const systemPrefersDark = ref(mediaQuery.matches)

  const isDark = computed(() => {
    if (themeMode.value === 'dark') return true
    if (themeMode.value === 'light') return false
    return systemPrefersDark.value
  })

  const applyTheme = () => {
    document.documentElement.classList.toggle('dark', isDark.value)
  }

  // Watch for mode changes
  watch(isDark, applyTheme, { immediate: true })

  // Listen for OS preference changes and update reactive ref
  const onMediaChange = (e) => { systemPrefersDark.value = e.matches }
  mediaQuery.addEventListener('change', onMediaChange)
  onUnmounted(() => mediaQuery.removeEventListener('change', onMediaChange))

  const setTheme = (mode) => {
    store.dispatch('user/changeTheme', mode)
    store.dispatch('user/saveSettings')
  }

  return { themeMode, isDark, setTheme }
}
